.badge {
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: var(--pill-bg);
  color: var(--muted);
  font-size: 12px;
}

.self {
  color: var(--ok);
  border-color: color-mix(in srgb, var(--ok) 40%, transparent);
}

.mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
}

.subhead {
  margin: 4px 0 8px;
  font-size: 15px;
}

.events {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.event {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid var(--line);
}

.event > span {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.hint {
  color: var(--muted);
  font-size: 13px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
}

.field {
  display: grid;
  gap: 8px;
  align-content: start;
}

.label {
  color: var(--muted);
  font-size: 12px;
}

.quiet {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quiet input {
  width: auto;
  min-width: 0;
  flex: 1;
  padding: 8px 10px;
}

.quiet input:disabled {
  opacity: 0.5;
}

.check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.check input {
  width: auto;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.status {
  color: var(--muted);
  font-size: 14px;
}

.switch {
  all: unset;
  flex: none;
  cursor: pointer;
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: var(--line);
}

.switch::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--surface);
}

.switch[aria-checked='true'] {
  background: var(--ok);
}

.switch[aria-checked='true']::after {
  transform: translateX(16px);
}

.switch:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: no-preference) {
  .switch,
  .switch::after {
    transition: background 0.2s, transform 0.2s;
  }
}
